// extracted by mini-css-extract-plugin
module.exports = {"tourList":"tourList__tourList___OxUMq","placeHolderShimmer":"tourList__placeHolderShimmer___10_Oa"};